/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, PageGridContainer, Typography } from '@coursera/cds-core';

import type { CarouselCollection } from 'bundles/collections-carousel/types/CarouselCollection';
import ProductCardCollection from 'bundles/collections-common/components/ProductCardCollection';
import ProductCardCollectionPlaceholder from 'bundles/collections-common/components/ProductCardCollectionPlaceholder';

const styles = {
  collectionTitle: css`
    margin-bottom: var(--cds-spacing-300);
  `,
};

type Props = {
  isCollectionLoading?: boolean;
  collection?: CarouselCollection;
};

const CollectionModule = ({ isCollectionLoading, collection }: Props) => {
  if (isCollectionLoading) {
    return (
      <PageGridContainer>
        <Grid item xs={12}>
          <ProductCardCollectionPlaceholder />
        </Grid>
      </PageGridContainer>
    );
  }

  if (!collection) {
    return null;
  }

  return (
    <PageGridContainer>
      <Grid item xs={12}>
        <ProductCardCollection
          collection={{
            ...collection,
            header: (
              <Typography variant="h1semibold" component="h2" css={styles.collectionTitle}>
                {collection.title}
              </Typography>
            ),
          }}
        />
      </Grid>
    </PageGridContainer>
  );
};

export default CollectionModule;
